import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import NotFound from "./ErrorPage/PageNotFound";
import Unauthorized from "./ErrorPage/Unauthorized";
import ThemeSettings from "./components/ThemeSettings";
import VendorForm from "./components/VendorManagement/VendorForm";
import PrivateRoute from "./route/privateRoute";
import RawDataList from "./components/RawDataMaster/RawDataList";
import NitMaster from "./components/NitMAster/NitMaster";
import AddNit from "./components/NitMAster/AddNit";
import TripPerformance from "./components/TripPerformance/TripPerformance";
import { Details } from "@material-ui/icons";
// Lazy-loaded components
const Login = lazy(() => import("./components/Login"));
const UserList = lazy(() => import("./components/UserManagement/userList"));
const AddUser = lazy(
  () => import("./components/UserManagement/UserManagement"),
);
const Users = lazy(() => import("./components/UserManagement/UserManagement"));
const ConfigurationMaster = lazy(
  () => import("./components/ConfigurationMaster/ConfigurationMaster"),
);


const VehicleConfigurationManager = lazy(
  () => import("./components/VehicleConfiguration/vehicleConfigurationManager"),
);
const SkipGeofenceConfiguration = lazy(
  () =>
    import(
      "./components/ConfigurationMaster/SkipGeofenceConfiguration"
    ),
);

const PowerCutConfiguration = lazy(
  () =>
    import(
      "./components/ConfigurationMaster/PowerCutConfiguration"
    ),
);

const MenuMasterConfiguration = lazy(
  () =>
    import(
      "./components/ConfigurationMaster/MenuMasterConfiguration"
    ),
);

const SchedulerManagement = lazy(
  () =>
    import(
      "./components/ConfigurationMaster/SchedulerManagement"
    ),
);

const AddSite = lazy(() => import("./components/Site/NewAddSite2"));
const Sitehistory = lazy(() => import("./components/Site/Sitehistory"));
const VehicleList = lazy(
  () => import("./components/VehicleManagement/vehicleList"),
);
const AddVehicle = lazy(
  () => import("./components/VehicleManagement/addVehicle"),
);
const VendorList = lazy(
  () => import("./components/VendorManagement/vendorList"),
);
const AddVendor = lazy(() => import("./components/VendorManagement/addVendor"));
const Vehicles = lazy(
  () => import("./components/VehicleManagement/viewVehicle"),
);
const Vendors = lazy(() => import("./components/VendorManagement/viewVendor"));
const RouteList = lazy(() => import("./components/RouteManagement/routeList"));
const AddRoute = lazy(() => import("./components/RouteManagement/addRoute1"));
const ViewRoute = lazy(() => import("./components/RouteManagement/viewRoute"));
const TripList = lazy(() => import("./components/TripManagement/tripList"));
const ViewTrip = lazy(() => import("./components/TripManagement/viewTrip"));
const AddTrip = lazy(() => import("./components/TripManagement/addTrip"));
const Reports = lazy(() => import("./components/Reports/reportCommony"));
const UpTimeReports = lazy(() => import("./components/Reports/report"));

const SiteManagement = lazy(() => import("./components/Site/siteManagement"));
const SiteDistanceManagement = lazy(() => import("./components/Site/SiteDistanceManagement"));
const AddSiteDistanceManagement = lazy(() => import("./components/Site/AddSiteDistanceManagement"));
const SiteManagement2 = lazy(() => import("./components/Site/siteManagement2"));

const ViewUser = lazy(() => import("./components/Site/viewUser"));
const LiveTracking = lazy(() => import("./components/Tracking/live"));
const HistoryTracking = lazy(() => import("./components/Tracking/history"));
const Dashboard = lazy(() => import("./components/Dashboard/dashboard"));
const FuelDashboard = lazy(() => import("./components/FuelReports/dashboard"));
const KMLView = lazy(() => import("./components/kmlFile/index"));
const Alerts = lazy(() => import("./components/Alerts/index"));

const TripMap = lazy(() => import("./components/TripManagement/tripMaps"));
const ReportMapDetails = lazy(
  () => import("./components/Reports/reportMapDetails"),
);
const NotificationList = lazy(
  () => import("./components/Notification/notificationNew"),
);
const UpTimeMonthly = lazy(
  () => import("./components/Notification/upTimeMonthly"),
);
const NitReport = lazy(
  () => import("./components/NitMAster/NitReport"),
);

const VehicleStatus = lazy(
  () => import("./components/Reports/VehicleStatus")
);

const NotificationConfiguration = lazy(
  () => import("./components/ConfigureManagement/Notification_Configuration"),
);
const AddNotification = lazy(
  () =>
    import("./components/ConfigureManagement/add_notication/Add_Notification_Configuration"),
);
const Dashboard2 = lazy(() => import("./components/Dashboard/Dashboard2"));
const CurrentOperationalStatus = lazy(
  () =>
    import("./components/CurrentOperationalStatus/CurrentOperationalStatus"),
);
const VehicleInteractionNotesList = lazy(
  () =>
    import("./components/VehicleInteractionNotes/VehicleInteractionNotesList"),
);
const EventApprover = lazy(
  () => import("./components/EventApprover/ApprovalList"),
);
const RolePermissionManager = lazy(
  () => import("./components/RolePermissionManager/RolePermissionManager"),
);

const DataLoss = lazy(() => import("./components/Analysis/DataLoss"));
const RawLoggedData = lazy(() => import("./components/Analysis/RawLoggedData"));
const CustomDrawingManager = lazy(
  () => import("./components/Dashboard/CustomDrawingManager"),
);
const Dashboard3 = lazy(() => import("./components/Dashboard/Dashboard3"));
const ReportsGps = lazy(() => import("./components/ReportsGps/ReportsGps"));
const NewAddSite2 = lazy(() => import("./components/Setup/NewAddSite2"));
const OperatingStations = lazy(
  () => import("./components/Setup/OperatingStations"),
);
const DayWiseUptimeReoprt = lazy(
  () => import("./components/Notification/DayWiseUptimeReoprt"),
);
const LandmarkList = lazy(
  () => import("./components/LandmarkManagement/LandmarkList"),
);
const AddLandmark = lazy(
  () => import("./components/LandmarkManagement/AddLandmark"),
);
const GpsDetailList = lazy(
  () => import("./components/GpsDetails/GpsDetailList"),
);
const ApproveAlert = lazy(
  () => import("./components/Notification/ApproveAlert"),
);const VehicleStuckAlert = lazy(
  () => import("./components/Notification/VehicleStuckAlert"),
);

// Route config
const routes = Object.freeze([
  { path: "/", element: <Login />, auth: false },
  {
    path: "/userlist",
    element: (
      <PrivateRoute requiredPermission="ADMINISTRATION_MANAGEMENT">
        {" "}
        <UserList />{" "}
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/adduser",
    element: (
      <PrivateRoute requiredPermission="ADMINISTRATION_MANAGEMENT">
        <AddUser />{" "}
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/users/:userId?",
    element: (
      <PrivateRoute requiredPermission="ADMINISTRATION_MANAGEMENT">
        {" "}
        <Users />{" "}
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/RewDataList",
    element: (
      <PrivateRoute requiredPermission="RAW_DATA_MASTER">
        <RawDataList />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/ConfigurationMaster",
    element: (
      <PrivateRoute requiredPermission="CONFIGURATION_MASTER">
        <ConfigurationMaster />
      </PrivateRoute>
    ),
    auth: true,
  },

  {
    path: "/vehicleConfigurationManager",
    element: (
      <PrivateRoute requiredPermission="CONFIGURATION_MASTER">
        <VehicleConfigurationManager />
      </PrivateRoute>
    ),
    auth: true,
  },


  {
  path: "/ConfigurationMaster/skip-geofence",
  element: (
    <PrivateRoute requiredPermission="CONFIGURATION_MASTER">
      <SkipGeofenceConfiguration />
    </PrivateRoute>
  ),
  auth: true,
},

{
  path: "/ConfigurationMaster/power-cut",
  element: (
    <PrivateRoute requiredPermission="CONFIGURATION_MASTER">
      <PowerCutConfiguration />
    </PrivateRoute>
  ),
  auth: true,
},

{
  path: "/ConfigurationMaster/menu-master",
  element: (
    <PrivateRoute requiredPermission="CONFIGURATION_MASTER">
      <MenuMasterConfiguration />
    </PrivateRoute>
  ),
  auth: true,
},

{
  path: "/ConfigurationMaster/scheduler",
  element: (
    <PrivateRoute requiredPermission="CONFIGURATION_MASTER"
     requiredRole="ADMIN"
     >
      <SchedulerManagement />
    </PrivateRoute>
  ),
  auth: true,
},

  {
    path: "/vehiclelist",
    element: (
      <PrivateRoute requiredPermission="VEHICLE_MANAGEMENT">
        {" "}
        <VehicleList />{" "}
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/addvehicle",
    element: (
      <PrivateRoute requiredPermission="VEHICLE_MANAGEMENT">
        <AddVehicle />{" "}
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/vehicles/:id?",
    element: (
      <PrivateRoute requiredPermission="VEHICLE_MANAGEMENT">
        <Vehicles />{" "}
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/transporters/:id?",
    element: (
      <PrivateRoute requiredPermission="TRANSPORTER_MANAGEMENT">
        <VendorForm />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/transporterlist",
    element: (
      <PrivateRoute requiredPermission="TRANSPORTER_MANAGEMENT">
        {" "}
        <VendorList />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/addtransporter",
    element: (
      <PrivateRoute requiredPermission="TRANSPORTER_MANAGEMENT">
        <VendorForm />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/routelist",
    element: (
      <PrivateRoute requiredPermission="ROUTE_MANAGEMENT">
        {" "}
        <RouteList />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/addroute",
    element: (
      <PrivateRoute requiredPermission="ROUTE_MANAGEMENT">
        <AddRoute />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/routes/:id?",
    element: (
      <PrivateRoute requiredPermission="ROUTE_MANAGEMENT">
        <ViewRoute />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/triplist",
    element: (
      <PrivateRoute requiredPermission="TRIP_MANAGEMENT">
        {" "}
        <TripList />{" "}
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/addtrip",
    element: (
      <PrivateRoute >
        <AddTrip />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/trips/:id?",
    element: (
      <PrivateRoute >
        <ViewTrip />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/reports",
    element: (
      <PrivateRoute >
        <Reports />
      </PrivateRoute>
    ),
    auth: true,
  },

  {
  path: "/vehicleStatus",
  element: (
    <PrivateRoute requiredPermission="REPORTS">
      <VehicleStatus />
    </PrivateRoute>
  ),
  auth: true,
},

  {
    path: "/sitelist",
    element: (
      <PrivateRoute requiredPermission="SITE_MANAGEMENT">
        <SiteManagement />
      </PrivateRoute>
    ),
    auth: true,
  },{
    path: "/siteDistancelist",
    element: (
      <PrivateRoute requiredPermission="SITE DISTANCE MANAGEMENT">
        <SiteDistanceManagement />
      </PrivateRoute>
    ),
    auth: true,
  },

  {
    path: "/addSiteDistance/:id?",
    element: (
      <PrivateRoute requiredPermission="SITE DISTANCE MANAGEMENT">
        <AddSiteDistanceManagement />
      </PrivateRoute>
    ),
    auth: true,
  },
  
  // {
  //   path: "/sitelist2",
  //   element: (
  //     <PrivateRoute>
  //       <SiteManagement2 />
  //     </PrivateRoute>
  //   ),
  //   auth: true,
  // },
  {
    path: "/viewUser/:id?",
    element: (
      <PrivateRoute >
        <ViewUser />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/site/:id?",
    element: (
      <PrivateRoute requiredPermission="SITE_MANAGEMENT">
        <AddSite />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/addSite",
    element: (
      <PrivateRoute requiredPermission="SITE_MANAGEMENT">
        <AddSite />
      </PrivateRoute>
    ),
    auth: true,
  },

  {
    path: "/sitehistory/:id?",
    element: (
      <PrivateRoute requiredPermission="SITE_MANAGEMENT">
        <Sitehistory />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/live/:id?",
    element: (
      <PrivateRoute >
        <LiveTracking />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/history/:id?",
    element: (
      <PrivateRoute requiredPermission="TRACK_HISTORY">
        <HistoryTracking />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/dashboardold",
    element: (
      <PrivateRoute >
        <Dashboard />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/dashboard1",
    element: (
      <PrivateRoute >
        <Dashboard2 />{" "}
      </PrivateRoute>
    ),
    auth: true,
  },
  // { path: "/Reportsgps", element: <AllReportPage /> },

  {
    path: "/fuelDashboard",
    element: (
      <PrivateRoute requiredPermission="FUEL_DASHBOARD">
        {" "}
        <FuelDashboard />{" "}
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/kmlview",
    element: (
      <PrivateRoute>
        {" "}
        <KMLView />{" "}
      </PrivateRoute>
    ),
    auth: true,
    auth: true,
  },
  {
    path: "/alerts",
    element: (
      <PrivateRoute>
        {" "}
        <Alerts />{" "}
      </PrivateRoute>
    ),
    auth: true,
    auth: true,
  },

  {
    path: "/reportDetails",
    element: (
      <PrivateRoute>
        <ReportMapDetails />{" "}
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/tripTrack/:id?",
    element: (
      <PrivateRoute requiredPermission="TRIP_MANAGEMENT">
        {" "}
        <TripMap />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/audit",
    element: (
      <PrivateRoute>
        <Reports />{" "}
      </PrivateRoute>
    ),
  },
  {
    path: "/activeRoutes",
    element: (
      <PrivateRoute>
        {" "}
        <Reports />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/upTime",
    element: (
      <PrivateRoute requiredPermission="REPORTS">
        {" "}
        <DayWiseUptimeReoprt />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/notification",
    element: (
      <PrivateRoute requiredPermission="VEHICLE_REPORT">
        {" "}
        <NotificationList />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/uptimeMonthly",
    element: (
      <PrivateRoute requiredPermission="REPORTS">
        {" "}
        <UpTimeMonthly />
      </PrivateRoute>
    ),
    auth: true,
  },  {
    path: "/nitReport",
    element: (
      <PrivateRoute requiredPermission="REPORTS">
        {" "}
        <NitReport />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/notificationConfigure",
    element: (
      <PrivateRoute requiredPermission="NOTIFICATION CONFIGURATION">
        {" "}
        <NotificationConfiguration />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/NitMaster",
    element: (
      <PrivateRoute requiredPermission="NIT_MASTER">
        {" "}
        <NitMaster />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/addNit/:id?",
    element: (
      <PrivateRoute requiredPermission="NIT_MASTER">
        {" "}
        <AddNit />
      </PrivateRoute>
    ),
    auth: true,
  },

  {
    path: "/TripPerformance",
    element: (
      <PrivateRoute requiredPermission="TRIP_PERFORMANCE">
        {" "}
        <TripPerformance />
      </PrivateRoute>
    ),
    auth: true,
  },

  {
    path: "/LandmarkList",
    element: (
      <PrivateRoute requiredPermission="LANDMARK_MANAGEMENT">
        <LandmarkList />
      </PrivateRoute>
    ),
    auth: true,
  },

  {
    path: "/addLandmark/:id?",
    element: (
      <PrivateRoute requiredPermission="LANDMARK_MANAGEMENT">
        <AddLandmark />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/addNotification",
    element: (
      <PrivateRoute requiredPermission="NOTIFICATION CONFIGURATION">
        {" "}
        <AddNotification />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/viewNotification/:id?/:isUnauthorized?",
    element: (
      <PrivateRoute requiredPermission="NOTIFICATION CONFIGURATION">
        <AddNotification />{" "}
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/OperatingStations",
    element: (
      <PrivateRoute >
        {" "}
        <OperatingStations />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/RawLoggedData",
    element: (
      <PrivateRoute>
        {" "}
        <RawLoggedData />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/DataLoss",
    element: (
      <PrivateRoute requiredPermission="DATA_LOSS_REPORT">
        <DataLoss />
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/currentOperationalStatus",
    element: (
      <PrivateRoute requiredPermission="CURRENT_OPERATIONAL_STATUS">
        <CurrentOperationalStatus />{" "}
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/Dashboard",
    element: (
      <PrivateRoute requiredPermission="DASHBOARD">
        <Dashboard3 />{" "}
      </PrivateRoute>
    ),
    auth: true,
  },

  {
    path: "/approvalAlert",
    element: (
      <PrivateRoute requiredPermission="VEHICLE_REPORT">
        <ApproveAlert />{" "}
      </PrivateRoute>
    ),
    auth: true,
  },


  {
    path: "/vehicleStuckAlert",
    element: (
      <PrivateRoute requiredPermission="VEHICLE_REPORT">
        <VehicleStuckAlert />{" "}
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/vehicleInteractionNotes",
    element: (
      <PrivateRoute requiredPermission="VEHICLE_INTERRACTION">
        <VehicleInteractionNotesList />{" "}
      </PrivateRoute>
    ),
    auth: true,
  },
  {
    path: "/Reportsgps",
    element: (
      <PrivateRoute requiredPermission="REPORTS">
        <ReportsGps />{" "}
      </PrivateRoute>
    ),
  },
  {
    path: "/eventApprover",
    element: <EventApprover />,
  },
  {
    path: "/rolePermissionManager",
    element: (
      <PrivateRoute requiredPermission="ADMINISTRATION_MANAGEMENT">
        <RolePermissionManager />{" "}
      </PrivateRoute>
    ),
  },
  {
    path: "/GpsDetailList",
    element: (
      <PrivateRoute>
        <GpsDetailList />{" "}
      </PrivateRoute>
    ),
  },

  {
    path: "/addstation",
    element: <NewAddSite2 />,
  },
  {
    path: "/CustomDrawingManager",
    element: <CustomDrawingManager />,
  },
  {
    path: "/ThemeSettings",
    element: <ThemeSettings />,
  },

  { path: "/unauthorized", element: <Unauthorized />, auth: false },
  { path: "*", element: <NotFound />, auth: false }, // catch-all for 404
]);

const Navigation = () => {
  return (
    <main className="App">
      <Routes>
        {routes?.map(({ path, element, auth, roles }, idx) => (
          <Route key={idx} path={path} element={element} />
        ))}
      </Routes>
    </main>
  );
};

export default Navigation;
